import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Alert } from 'reactstrap';
import CompanyAutocomplete from './CompanyAutocomplete';
import UsersAutocomplete from './Numbers/UsersAutocomplete';
import Toggle from './Toggle';

const Provisions = ({
  telephoneNumber,
  companies,
  gateways,
  filterEmails,
  index,
  isDisabled,
  companySearchFilter,
  onOrder,
  orderedNumbers, trunks, provider
}) => {
  const { defaultValue, trunkGroupList } = trunks
  const [company, setCompany] = useState('');
  const [uid, setUid] = useState('');
  const [tempDID, setTempDID] = useState(false);
  const [route, setRoute] = useState(gateways[1].route);
  const [sms, setSms] = useState(false);
  const [numberOrdered, setNumberOrdered] = useState(false);
  const [disableCheck, setDisableCheck] = useState(true);
  const unifiedRoute = { gateway: '208.65.249.104:5080', route: '1804' };
  const companyChange = e => {
    if (e.suggestion !== null) {
      setCompany(e.suggestion);
    } else {
      setCompany('');
    }
  };

  const userChange = e => {
    if (e.suggestion !== null) {
      setUid(e.suggestion._id);
    } else {
      setUid('');
    }
  };

  const onTempChange = () => {
    setTempDID(!tempDID);
  };

  const enableSms = e => {
    setSms(!sms);
  };

  useEffect(() => {
    if (company !== '' && route !== unifiedRoute.route) {
      setDisableCheck(false);
    } else {
      setDisableCheck(true);
    }
  });

  useEffect(() => {
    setRoute(provider == "Inteliquent" ? defaultValue : JSON.stringify(unifiedRoute));
  }, []);

  useEffect(() => {
    if (orderedNumbers.length !== 0) {
      orderedNumbers.forEach(num => {
        if (telephoneNumber === num.tn) {
          setNumberOrdered(true);
        }
      });
    }
  }, [orderedNumbers]);
  return (
    <tr>
      <td>{telephoneNumber}</td>
      <td>
        <Toggle
          value={sms}
          onToggle={() => {
            if (index !== 0 && isDisabled) {
              console.log('disabled');
            } else {
              enableSms();
            }
          }}
        />
      </td>
      <td style={{ width: '20%' }}>
        {provider != "Inteliquent" ? <Input
          type="select"
          disabled={index !== 0 && isDisabled}
          onChange={e => setRoute(e.currentTarget.value)}
        >
          {gateways.map((el, idx) => (
            <option
              selected={el.gateway === '208.65.249.104:5080'}
              key={idx}
              value={JSON.stringify(el)}
            >
              {el.gateway === '208.65.249.104:5080' ? 'unified.epik.io' : el.gateway}
            </option>
          ))}
        </Input> :
          <Input
            type="select"
            defaultValue={defaultValue}
            disabled={index !== 0 && isDisabled}
            onChange={e => setRoute(e.currentTarget.value)}
          >
            {trunkGroupList.map((el, idx) => (
              <option
                key={idx}
                value={el.trunkGroupName}
              >
                {el.trunkGroupName}
              </option>
            ))}
          </Input>}
      </td>
      <td style={{ width: '20%' }}>
        {companies && (
          <CompanyAutocomplete
            isDisabled={index !== 0 && isDisabled}
            key={telephoneNumber}
            placeholder="Company..."
            companies={companies}
            onChange={ev => {
              companyChange(ev);
              companySearchFilter(ev);
            }}
          />
        )}
      </td>
      <td>
        {filterEmails !== null && filterEmails.length !== 0 && company !== '' ? (
          <UsersAutocomplete
            disabledAdmin={index !== 0 && isDisabled}
            key={telephoneNumber}
            searchTerm={filterEmails.email}
            placeholder="Default User"
            calls={filterEmails.emails[`${company.name}`] || []}
            onChange={ev => {
              userChange(ev);
            }}
          />
        ) : (
          <Alert rowSpan={12} color="info">
            Please Select Company
          </Alert>
        )}
      </td>
      <td className='d-flex justify-content-center align-items-center'>
        <Input
          className="tempDIDCheck"
          type="checkbox"
          disabled={index !== 0 && isDisabled}
          checked={tempDID}
          onChange={onTempChange}
        />
      </td>
      <td>
        {!numberOrdered ? (
          <Button
            disabled={disableCheck}
            color="primary"
            onClick={() =>
              onOrder({
                tn: telephoneNumber,
                sms,
                route,
                uid,
                cid: company._id,
                tempDID,
              })
            }
          >
            Order
          </Button>
        ) : (
          <Button disabled color="info">
            Complete
          </Button>
        )}
      </td>
    </tr>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
  trunks: state.AppState.provisioning.trunkGroupList,
});

export default connect(mapStateToProps)(Provisions);
